import * as ST from './styled';

/**
 * @deprecated
 */
interface ResultMessageProps {
    message: string | JSX.Element,
    imgSrc: string,
    symbolId?: string,
    imgWidth?: string,
    imgHeight?: string,
    isResultNoFreeTime?: boolean,
    className?: string,
    isError?: boolean,
}

/**
 * @deprecated use @r1-frontend/ui-react/alert
 */
export const ResultMessage = ({ message, imgSrc, symbolId, imgWidth, imgHeight, isResultNoFreeTime, className, isError }: ResultMessageProps): JSX.Element => {
    return (
        <ST.ResultMessage isResultNoFreeTime={isResultNoFreeTime} className={className} isError={isError}>
            <ST.IconWrap>
                {!symbolId
                    ? <ST.Icon src={imgSrc}/>
                    : <svg width={imgWidth || 20} height={imgHeight || 20}>
                        <use href={`${imgSrc}#${symbolId}`}/>
                    </svg>
                }
            </ST.IconWrap>
            {message}
        </ST.ResultMessage>
    );
};
